import React, { forwardRef } from "react";
import classnames from "classnames";

import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button, IButtonProps } from "./Button";
import styles from "./LineButton.scss";

export interface ILineButtonProps {
    icon?: IconName;
    toggled?: boolean;
    responsive?: boolean;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
}

export const LineButton = forwardRef<
    HTMLButtonElement & HTMLAnchorElement,
    ILineButtonProps & IButtonProps
>(function LineButton(props, ref) {
    const {
        icon,
        toggled,
        responsive,
        className,
        children,
        placeholder,
        disabled,
        ...rest
    } = props;

    return (
        <Button
            ref={ref}
            className={classnames(
                styles["line-button"],
                styles.button,
                toggled && styles.toggled,
                responsive && styles.responsive,
                className,
            )}
            {...rest}
            type="button"
            disabled={disabled}
        >
            {icon && <Icon name={icon} />}
            <span className={!children ? styles.placeholder : undefined}>
                {children || placeholder}
            </span>
        </Button>
    );
});
